import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { tap } from "rxjs/operators";

@Injectable()
export class ProvidersService {
  constructor(private http: HttpClientService) {}

  getProviders(category?) {
    const options = {
      params: {
        category,
      },
    };
    return this.http.get("/api/providers", options).pipe(tap((_) => console.log("ProvidersService.getProviders: Ok.")));
  }

  getUsers(id, tipo?) {
    const options = {
      params: {
        tipo,
      },
    };
    return this.http
      .get("/api/providers/" + id + "/users", options)
      .pipe(tap((_) => console.log("ProvidersService.getUsers: Ok.")));
  }

  addEmail(id, email, active = true) {
    const options = { email, active };
    return this.http
      .post("/api/providers/" + id + "/email", options)
      .pipe(tap((_) => console.log("ProvidersService.addEmail: Ok.")));
  }

  addPhone(id, phone_number, active = true, category = "work", principal = false, communication_wp = false) {
    const options = {
      info: phone_number,
      active,
      category,
      principal,
      communication_wp,
    };
    return this.http
      .post("/api/providers/" + id + "/phone_number", options)
      .pipe(tap((_) => console.log("ProvidersService.addEmail: Ok.")));
  }
}
